import { Bike, Store } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatRupiah } from "@/lib/api";

const OPTIONS = [
  { id: "ambil", label: "Ambil sendiri", sub: "Gratis", icon: Store },
  { id: "antar", label: "Diantar", sub: "Kena ongkir", icon: Bike },
];

export const DeliveryPicker = ({ store, value, onChange }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-3" data-testid="delivery-picker">
      <p className="text-sm font-medium">Pengambilan Pesanan</p>
      <div className="grid grid-cols-2 gap-2">
        {OPTIONS.map(({ id, label, sub, icon: Icon }) => (
          <button key={id} type="button" onClick={() => set("method", id)} aria-pressed={value.method === id} data-testid={`delivery-method-${id}`}
            className={`rounded-xl border-2 p-3 text-left transition-colors ${value.method === id ? "border-emerald-600 bg-emerald-50 text-emerald-800" : "border-slate-200 text-slate-600 hover:border-slate-300"}`}>
            <Icon className="h-5 w-5" />
            <p className="mt-1 text-sm font-bold">{label}</p>
            <p className="text-xs opacity-75">{sub}</p>
          </button>
        ))}
      </div>
      {value.method === "antar" && (
        <div className="space-y-3 rounded-xl bg-slate-50 p-3">
          <div className="space-y-1.5">
            <Label htmlFor="delivery-address">Alamat pengiriman</Label>
            <Input id="delivery-address" maxLength={200} value={value.address} onChange={(e) => set("address", e.target.value)} placeholder="Jl. ..., patokan" className="bg-white" data-testid="delivery-address-input" />
          </div>
          {store.delivery_mode === "per_km" && (
            <div className="space-y-1.5">
              <Label htmlFor="delivery-km">Perkiraan jarak dari toko (km) &middot; {formatRupiah(store.rate_per_km)}/km</Label>
              <Input id="delivery-km" type="number" inputMode="decimal" min="0.1" max="100" step="0.1" value={value.km} onChange={(e) => set("km", e.target.value)} className="bg-white" data-testid="delivery-km-input" />
            </div>
          )}
          {store.delivery_mode === "zona" && (
            <div className="space-y-1.5">
              <p className="text-sm font-medium">Zona pengiriman</p>
              <div className="grid gap-2">
                {(store.zones || []).map((z, i) => (
                  <button key={i} type="button" onClick={() => set("zone", String(i))} data-testid={`delivery-zone-${i}`}
                    className={`flex justify-between rounded-lg border px-3 py-2 text-sm transition-colors ${value.zone === String(i) ? "border-emerald-600 bg-white font-semibold text-emerald-800" : "border-slate-200 bg-white text-slate-600"}`}>
                    <span>{z.name}</span><span className="font-mono">{formatRupiah(z.fee)}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
          {store.delivery_mode === "menyusul" && (
            <p className="text-xs text-slate-500" data-testid="delivery-fee-later">Ongkir akan dikonfirmasi toko lewat WhatsApp.</p>
          )}
        </div>
      )}
    </div>
  );
};
